import LeaseTermsTooltip from './lease-terms-tooltip';

export default LeaseTermsTooltip;
